@if (!mobileWindow) {
  <section id="wallet-action-buttons">
    <fiat-action-buttons [wallet]="wallet" [alternateFiat]="fiat"></fiat-action-buttons>
  </section>
} @else {
  <span class="mobile-actionbutton-main-bg"></span>
  <span class="mobile-actionbutton-main" [class.isVisible]="joinedActionButtonClicked" (click)="mainButtonToggle()">
    <span class="mobile-actionbutton-main-icon">
      @if (joinedActionButtonClicked) {
        <span class="bpi__icon-close"></span>
      } @else {
        <span class="bpi__icon-trade"></span>
      }
    </span>
  </span>
  <div class="mobile-actionbutton-slate" [class.isVisible]="joinedActionButtonClicked">
    <section id="wallet-action-buttons-mobile">
      <div class="mobile-actionbutton-title mod-fiat-title">
        {{ getFiat().getName() }} {{ "wallet" | translate }}
      </div>
      <div class="pb-30">
        <div class="mobile-actionbutton-title mod-fiat-amount">
          {{ wallet?.getBalance() | fiat_precision_symbol: { id: fiat.getId(), currencies: [fiat] } }}
        </div>
        @if (d_fiat?.getId() !== fiat?.getId()) {
          <div
            class="mobile-actionbutton-title mod-fiat-amount-exchange"
            >
            {{ exchanged | fiat_precision_symbol: { id: d_fiat.getId(), currencies: [d_fiat] } }}
          </div>
        }
      </div>
      <fiat-action-buttons [wallet]="wallet" [alternateFiat]="fiat"></fiat-action-buttons>
    </section>
  </div>
}
